import React from 'react'
import { Box, Input } from '@maui/elements'
import { LayoutColumn, LayoutWrapper, Label } from '.'
import { Frequency, Delivery } from './fields'
import { useDraft } from '@maui/hooks'

export const MigratedDataBanner = () => {
  return (
    <Box
      data-testid="MigratedDataBanner"
      width="445px"
      bg="colorBackgroundOverlay"
      p="spacePaddingXLarge"
      borderLeft="8px"
      borderLeftColor="colorActivePrimary"
      borderLeftStyle="solid"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      This was migrated from a legacy system. We have selected your local timezone location, {Intl.DateTimeFormat().resolvedOptions().timeZone}. You may accept this or select another timezone, then Save.
    </Box>
  )
}

export const BaseFormContent = ({
  register,
  control,
  deliveryFreq,
  errors,
  clearErrors,
  setValue,
  DropdownComponent,
  profiles,
  threatProfileDigest = false,
  timezoneValid = true,
}) => {
  const [frequency, setFrequency] = useDraft(deliveryFreq || 'DAILY')

  return (
    <>
      <LayoutWrapper>
        <LayoutColumn maxWidth="256px" width='100%'>
          <LayoutColumn gap='spaceGapSmall' mb='spaceGapMedium'>
            <Label htmlFor='name'>
              Name
            </Label>
            <Input
              size="medium"
              name="name"
              id="name"
              placeholder="Choose a name for this digest"
              {...register('name', { required: true })}
              variant={errors?.name || errors?.root?.serverError?.message.includes('name') ? 'error' : 'primary'}
            />
          </LayoutColumn>
          <LayoutColumn gap='spaceGapSmall' mb='spaceGapMedium'>
            <Label htmlFor='emailAddress'>
              Mailing to
            </Label>
            <Input size="medium" name='emailAddress' id='emailAddress' {...register('emailAddress')} disabled />
          </LayoutColumn>
          {DropdownComponent && <DropdownComponent control={control} profiles={profiles} errors={errors} />}
        </LayoutColumn>
        <LayoutColumn minWidth="445px">
          <Frequency
            control={control}
            register={register}
            errors={errors}
            clearErrors={clearErrors}
            setValue={setValue}
            threatProfileDigest={threatProfileDigest}
            frequency={frequency}
            setFrequency={setFrequency}
          />
          {frequency !== 'HOURLY' &&
            <Delivery control={control} register={register} />
          }
          {!timezoneValid && <MigratedDataBanner />}
        </LayoutColumn>
      </LayoutWrapper>
    </>
  )
}
